"use strict";

exports.__esModule = true;
exports.DeviceColorController = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DeviceColorSource = require("./DeviceColorSource");
var _LayoutSettingsContext = require("../../ConfigurableLayout/LayoutSettingsContext");
var _dec, _class, _DeviceColorController;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Determine the appropriate color and background color for an element.
 */
var DeviceColorController = exports.DeviceColorController = (_dec = _LayoutSettingsContext.LayoutSettingsContext.withContext, _dec(_class = (_DeviceColorController = /*#__PURE__*/function (_Component) {
  function DeviceColorController() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(DeviceColorController, _Component);
  var _proto = DeviceColorController.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      deviceUuid = _this$props.deviceUuid,
      color = _this$props.color,
      backgroundColor = _this$props.backgroundColor,
      colorSource = _this$props.colorSource,
      backgroundColorSource = _this$props.backgroundColorSource,
      value = _this$props.value,
      children = _this$props.children,
      layoutSettings = _this$props.layoutSettings;
    if (colorSource == null && backgroundColorSource == null) {
      return children({
        color: color,
        backgroundColor: backgroundColor
      });
    }
    if (colorSource != null) {
      if (backgroundColorSource != null) {
        return /*#__PURE__*/_react["default"].createElement(_DeviceColorSource.DeviceColorSource, {
          deviceUuid: deviceUuid,
          config: backgroundColorSource,
          defaultColor: backgroundColor,
          realtime: layoutSettings.colorSource.realtime,
          value: value
        }, function (backgroundColorFromSource) {
          return /*#__PURE__*/_react["default"].createElement(_DeviceColorSource.DeviceColorSource, {
            deviceUuid: deviceUuid,
            config: colorSource,
            defaultColor: color,
            realtime: layoutSettings.backgroundColorSource.realtime,
            value: value
          }, function (colorFromSource) {
            return children({
              color: colorFromSource,
              backgroundColor: backgroundColorFromSource
            });
          });
        });
      }
      return /*#__PURE__*/_react["default"].createElement(_DeviceColorSource.DeviceColorSource, {
        deviceUuid: deviceUuid,
        config: colorSource,
        defaultColor: color,
        realtime: layoutSettings.colorSource.realtime,
        value: value
      }, function (colorFromSource) {
        return children({
          color: colorFromSource,
          backgroundColor: backgroundColor
        });
      });
    }
    if (backgroundColorSource != null) {
      return /*#__PURE__*/_react["default"].createElement(_DeviceColorSource.DeviceColorSource, {
        deviceUuid: deviceUuid,
        config: backgroundColorSource,
        defaultColor: backgroundColor,
        realtime: layoutSettings.backgroundColorSource.realtime,
        value: value
      }, function (backgroundColorFromSource) {
        return children({
          color: color,
          backgroundColor: backgroundColorFromSource
        });
      });
    }
    return children({
      color: color,
      backgroundColor: backgroundColor
    });
  };
  return DeviceColorController;
}(_react.Component), _DeviceColorController.defaultProps = {
  layoutSettings: undefined
}, _DeviceColorController)) || _class);